// extracted by mini-css-extract-plugin
module.exports = {"body":"ModalBody_body__1Cfs6"};